<template>
    <v-dialog v-model="show" persistent no-click-animation width="500">
        <div class="ScenarioNodeSelector">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('nodeSelector') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div style="padding: 12px">
                <v-text-field
                    outlined
                    v-model="searchText"
                    :placeholder="$f.tc('search')"
                    class="input-custom"
                ></v-text-field>
                <div class="dialog-content fci-scrollbar">
                    <v-layout
                        v-for="(node, nodeIndex) in nodeListFilter"
                        :key="nodeIndex"
                        @click="select(node)"
                        class="pa-2 item"
                        align-center
                    >
                        <img :src="NodeIconMap[node.type]" alt="icon" class="mr-2" style="width: 24px; height: 24px;">
                        {{ node.name }}
                    </v-layout>
                </div>
            </div>
            <!--Footer dialog-->
            <div class="dialog-footer">
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseMixin from "@/modules/fptai/mixins/DialogPromiseMixin";
import ScenarioService from "@/services/scenario.service";
import {mapState} from "vuex";

const {NodeIconMap} = ScenarioService

export default {
    name: "ScenarioNodeSelector",
    mixins: [DialogPromiseMixin],
    data() {
        return {
            NodeIconMap,
            searchText: '',
            nodeList: []
        }
    },
    computed: {
        ...mapState({
            stateNodeList: state => state.scenario.treeData ? state.scenario.treeData.nodeList : []
        }),
        nodeListFilter() {
            let search = this.searchText.trim()
            return this.nodeList.filter(node => node.name.toLowerCase().includes(search) || node.id.includes(search))
        }
    },
    methods: {
        select(node) {
            this.searchText = ''
            this.promise.resolve(node)
            this.close()
        },
        open(nodeList) {
            this.nodeList = nodeList || this.stateNodeList
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        }
    }
}
</script>

<style scoped lang="scss">
.ScenarioNodeSelector {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .dialog-content {
        padding: 0 !important;
        height: 500px;
        overflow-y: auto;
    }

    .btn-custom {
        margin-left: 8px;
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.item {
    cursor: pointer;
    font-size: 14px;
    border-radius: 5px;
    padding: 0 12px !important;
    height: 48px;

    &:hover {
        background: #EEF6FF;
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
        position: relative;
    }
}
</style>
